import isNil from 'lodash/isNil';
import { useMemo } from 'react';
import { textOverflowSx } from '@/components/atoms/Typography/utils';
import { mergeSx } from '@/utils/cssStyles';

type UseTypographyOverflowArgs = {
  noOverflow?: { maxWidth: string | number };
};

export const useTypographyOverflow = ({ noOverflow }: UseTypographyOverflowArgs) => {
  const overflowSx = useMemo(() => {
    if (isNil(noOverflow)) {
      return null;
    }

    return mergeSx(textOverflowSx, { maxWidth: noOverflow.maxWidth });
  }, [noOverflow]);

  return {
    overflowSx,
  };
};
